import React, { Component } from 'react';
import './loginComponent.css';
import AutenticationService from '../services/authservice.js';
import LoginSrv from '../services/Api/Loginsrv/LoginSrv.js';
import { Spinner } from 'react-bootstrap';
//import validator from 'validator';

export default class LoginComponent extends Component {
  // constructor(props) {
  //   super(props);
  // }
  state = {
    userid: '',
    password: '',
    isLoged: false,
    noLoged: false,
    action: this.props.match.params.call,
    mesremo: '',
    loading: false,
  };

  render() {
    console.log('render : ', this.state.action);
    //const [validated, setValidated] = useState(false);
    return (
      <div className='LoginComponent '>
        <div className='row mr-0'>
          <div className='col-md-12 py-5 mt-5 d-flex flex-column justify-content-center'>
            <div className='row'>
              <div className='col-lg-6 col-md-8  mx-auto pl-4'>
                <div className='card rounded shadow shadow-sm'>
                  <div className='card-header'>
                    <h3 className='mb-0'>
                      Login &nbsp;
                      {this.state.loading && (
                        <Spinner animation='border' role='status'></Spinner>
                      )}
                    </h3>
                  </div>

                  <div className='card-body'>
                    <form
                      className='needs-validation'
                      autoComplete='off'
                      id='formLogin'
                      noValidate
                      //validated={validated}
                      // onSubmit={handleSubmit}
                      //validated={validated}
                    >
                      <div className='form-group'>
                        <label htmlFor='userid'>Nome</label>
                        <input
                          className='form-control form-control-lg rounded-0'
                          type='text'
                          name='userid'
                          required
                          value={this.state.userid}
                          onChange={this.GestMod}
                        ></input>
                        <div className='invalid-feedback'>
                          Oops, you missed this one.
                        </div>
                      </div>
                      <div className='form-group'>
                        <label>Password</label>
                        <input
                          className='form-control form-control-lg rounded-0'
                          id='password'
                          type='password'
                          name='password'
                          value={this.state.password}
                          onChange={this.GestMod}
                          required
                          autoComplete='new-password'
                        ></input>
                        <div className='invalid-feedback'>
                          Enter your password too!
                        </div>
                      </div>
                      <div>
                        <label className='custom-control custom-checkbox'>
                          <input
                            type='checkbox'
                            className='custom-control-input'
                          ></input>
                          <span className='custom-control-indicator'></span>
                        </label>
                      </div>

                      {/* <button
                        type='button'
                        className='btn btn-primary'
                        onClick={this.Login}
                      >
                        Accedi
                      </button> */}

                      <button
                        type='button'
                        onClick={this.Login}
                        className='btn btn-success btn-lg float-right'
                        id='btnLogin'
                      >
                        Login
                      </button>
                      <ConnexOkMessage isLoged={this.state.isLoged} />
                      <ConnexKoMessage noLoged={this.state.noLoged} />

                      {this.state.noLoged && (
                        <div>errore={this.state.mesremo} </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  handleError = (error) => {
    console.log(error);
    this.setState({ mesremo: error.message, loading: false });
    this.setState({ isLoged: false });
    this.setState({ noLoged: true });
  };
  handleResponse = (response, id) => {
    console.log(response.data);
    this.setState({ mesremo: response.data.id, loading: false });

    if (response.data.id === 'OK') {
      AutenticationService.saveUserInfo(
        this.state.password,
        this.state.userid,
        response.data.idute
      );
      debugger;
      AutenticationService.saveToken(response.data.token);
      setTimeout(() => {
        if (this.state.action === 'login') {
          this.props.history.push(`/cancello`); //alt0096 | alt gr +'
        } else {
          this.props.history.push(`/${this.state.action}`); //alt0096 | alt gr +'
        }
      }, 2000);

      this.setState({ isLoged: true });
      this.setState({ noLoged: false });
    } else {
      this.setState({ isLoged: false });
      this.setState({ noLoged: true });

      // if (form.checkValidity() === false) {
      //   event.preventDefault();
      //   event.stopPropagation();
      // }
      console.log(
        'OUTPUT: LoginComponent -> handleResponse -> datin',
        response.data
      );
    }
  };

  Login = (event) => {
    console.log('login1', event);
    event.preventDefault();
    this.setState({ loading: true });
    //const form = event.currentTarget;
    const dati = { nome: this.state.userid, password: this.state.password };
    LoginSrv.getLogin(dati)
      .then((response) => this.handleResponse(response, 'login'))
      .catch((error) => this.handleError(error));

    // if (this.state.userid === 'claudio' && this.state.password === '123*') {
    //   //   AutenticationService.saveUserInfo(this.state.password, this.state.userid);

    //   // //this.props.history.push(`/welcome/${this.state.userid}`); //alt0096 | alt gr +'
    //   // if (this.state.action === 'login') {
    //   //   this.props.history.push(`/cancello`); //alt0096 | alt gr +'
    //   // } else {
    //   //   this.props.history.push(`/${this.state.action}`); //alt0096 | alt gr +'
    //   // }

    //   this.setState({ isLoged: true });
    //   this.setState({ noLoged: false });
    // } else {
    //   this.setState({ isLoged: false });
    //   this.setState({ noLoged: true });
    //   const form = event.currentTarget;
    //   if (form.checkValidity() === false) {
    //     event.preventDefault();
    //     event.stopPropagation();
    //   }

    //   //setValidated(true);
    // }
  };
  //!------------------------------------------------------------------------------------------
  // ! INFO
  // ? evento unico att.ne i name degli input devono essere esattamente uguali ai nomi degli state
  //!------------------------------------------------------------------------------------------

  GestMod = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
}

//!----------------------------------------------
// lo stato cambia nel metodo Login
// e il messaggio viene creato e visualizzato in modo dinamico nelle funzioni
//!------------------------------------------------
//creo un componente funzione
function ConnexOkMessage(props) {
  if (props.isLoged) {
    return (
      <div>
        <h3>connessione avvenuta con successo</h3>
      </div>
    );
  }
  return null;
}
function ConnexKoMessage(props) {
  if (props.noLoged) {
    return (
      <div>
        <h3>connessione Fallita !!</h3>
      </div>
    );
  }
  return null;
}
